<template>
  <div>
    <div class="mb-4">
      <div class="font-weight-medium mb-1">Source copies</div>
      <div>{{ summary }}</div>
      <v-simple-table v-if="copyRows.length" dense class="mt-2">
        <thead>
          <tr><th>Copy</th><th>Interface</th><th>Bridge domain</th><th>Shut at</th><th>Removed</th></tr>
        </thead>
        <tbody>
          <tr v-for="c in copyRows" :key="`copy-${c.id}`">
            <td>{{ c.id }}</td>
            <td>{{ c.interfaceName }}</td>
            <td>{{ c.bridgeDomain }}</td>
            <td>{{ c.shutAtText }}</td>
            <td>{{ c.removedAtText }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <step-button
        name="canRemoveSourceCopies"
        :label="`Remove source copies on ${preflight.sourceHostname}...`"
        :steps="preflight.steps"
        :busy="busy"
        :loading="loadingKey === 'remove-source'"
        @click="removeOpen = true"
      />
    </div>

    <div v-if="record" class="grey--text text--darken-2">{{ pointer }}</div>

    <v-alert v-if="alert" :type="alert.type" dense outlined class="mt-3 mb-0">
      {{ alert.text }}
      <v-btn v-if="alert.type === 'error'" small text class="ml-2" @click="retryLast">Retry</v-btn>
    </v-alert>

    <type-to-confirm v-model="removeOpen" v-bind="removeDlg" :cvc-name="preflight.cvcName" @proceed="removeCopies" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import {
  dialogProps,
  removeSourceDialog,
  sourceCopiesSummary,
  sourceCopyRows,
} from "@/utils/cvcMigrationPage";
import { ROLLBACK_POINTER } from "@/utils/cvcMigrationRollback";
import StepButton from "./step-button";
import TypeToConfirm from "./type-to-confirm";
import SectionActions from "./section-actions";

// Section E: remove the shut source subinterfaces (after the safety days). The
// undo (cancel) lives in section R.
export default {
  name: "CvcMigrationCleanup",
  components: { StepButton, TypeToConfirm },
  mixins: [SectionActions],
  props: {
    preflight: { type: Object, required: true },
    cvcId: { type: Number, required: true },
    targetHostId: { type: Number, required: true },
    now: { type: Date, required: true },
  },
  data: () => ({
    pointer: ROLLBACK_POINTER,
    removeOpen: false,
  }),
  computed: {
    record () {
      return this.preflight.record;
    },
    summary () {
      return sourceCopiesSummary(this.preflight);
    },
    copyRows () {
      return sourceCopyRows(this.record, this.preflight.poiState);
    },
    removeDlg () {
      return dialogProps(removeSourceDialog(this.preflight));
    },
  },
  methods: {
    ...mapActions("cvcMigration", ["cvcMigrationRemoveSourceCopies"]),
    removeCopies ({ extra }) {
      this.run("remove-source", () => this.cvcMigrationRemoveSourceCopies({ cvcId: this.cvcId, agreedBy: extra }));
    },
  },
};
</script>
